/**
 * A barra que anuncia versão nova do app instalado.
 *
 * Fica no rodapé e não bloqueia nada: quem está no meio de um atendimento
 * continua atendendo e atualiza quando puder. Acima do indicador de home do
 * iPhone (`--safe-bottom`), senão o botão cai embaixo da barra do sistema.
 */
import { useTranslation } from "react-i18next";
import { RefreshCw, X } from "lucide-react";
import { usePWAStore } from "./registerSW";

export function UpdatePrompt() {
  const { t } = useTranslation();
  const precisaAtualizar = usePWAStore((s) => s.precisaAtualizar);
  const atualizar = usePWAStore((s) => s.atualizar);
  const dispensar = usePWAStore((s) => s.dispensar);

  if (!precisaAtualizar || !atualizar) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-0 bottom-0 z-50 flex items-center gap-3 border-t border-gray-200 bg-white px-4 py-3 shadow-lg dark:border-gray-700 dark:bg-gray-800 sm:inset-x-auto sm:bottom-4 sm:left-4 sm:rounded-lg sm:border"
      style={{ paddingBottom: "max(0.75rem, var(--safe-bottom))" }}
    >
      <RefreshCw className="h-5 w-5 shrink-0 text-primary-500" />
      <p className="flex-1 text-sm text-gray-700 dark:text-gray-200">
        {t("pwa.updateAvailable")}
      </p>
      <button
        type="button"
        onClick={atualizar}
        className="shrink-0 rounded-lg bg-primary-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-primary-600"
      >
        {t("pwa.update")}
      </button>
      <button
        type="button"
        onClick={dispensar}
        aria-label={t("common.close")}
        className="shrink-0 p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}

export default UpdatePrompt;
